<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<h1 style="color: #2d8cf0;">3.2、插入数据</h1>
					<h2 class="about-cs">3.2.1概念</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; 向数据库里的表插入数据好比向菜老板准备的笔记本里写字的过程，写这个动作对应insert into这个语句。
					</div>
					<h2 class="about-cs">3.2.2插入语句</font>
					</h2>
					<div class="about-t">


						&nbsp; &nbsp;&nbsp; &nbsp; 先给出建表语句，将如下语句复制既可以立马创建商品信息表。<br />
						<!-- 在这里传入后台返回的文本数据和关键字就可以了 -->
						<!-- <change-key-word keyword="关键字" text="这一行有一个关键字"> </change-key-word><br /> -->

                        样例：
						<sql-show :value="sqlInfo"> </sql-show>


						<!-- <div v-if="ifLogin"> -->
						<!-- <div style="padding-left: 50px;">
							<img style="width: 40px;" :src="require('../../assets/image/jiantou.png')">
							<a @click="toRunSql">打开我的在线sql学习编辑器 </a></br>
						</div> -->
						<!--  </div> -->
						语句解释：</br>
						<change-key-word keyword="创建MySQL数据表需要以下信息：" text="创建MySQL数据表需要以下信息：表名、表字段名、定义每个表字段类型。">
						</change-key-word><br />
						<change-key-word keyword="PRODUCT_T：" text="PRODUCT_T：是告诉数据库插入哪张表"> </change-key-word><br />
						 
						<change-key-word keyword="(PRODUCT_NO,  PRODUCT_NAME,  PRODUCT_NUM,     PRODUCT_PRICE  )："
							text="(PRODUCT_NO,  PRODUCT_NAME,  PRODUCT_NUM,     PRODUCT_PRICE  )：是告诉数据库插入表里的哪些字段。">
						</change-key-word><br />
						 
						<change-key-word keyword="values："
							text="values：关键字告诉数据库要开始插入真正的数据了。"> </change-key-word>
						<br />
						 
						<change-key-word keyword="('NO001',	  '晨光中性笔',  100,             1.52           )："
							text="('NO001',	  '晨光中性笔',  100,             1.52           )：插入的真正的值，这个顺序跟上面表字段的顺序是一一对应的。">
						</change-key-word><br />
						 
					</div>
					 
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import ChangeKeyWord from '@/components/project/ChangeKeyWord.vue'

	import SqlShow from '@/components/project/SqlShow.vue'
	export default {
		components: {
			ChangeKeyWord,
			SqlShow,
		},

		data() {
			return {
				userId: '',
				ifLogin: false,
				sqlInfo: 'insert into PRODUCT_T \r\n' +
					     '(PRODUCT_NO,  PRODUCT_NAME,  PRODUCT_NUM,     PRODUCT_PRICE  ) \r\n' +
					     'values\r\n' +
					     '(\'NO001\',   \'晨光中性笔\',  100,          1.52        );\r\n'  ,
	 
			}
		},

		created() {
			this.userId = this.$store.state.userInfo.userId;
			if (this.userId != undefined) {
				this.ifLogin = true;
			}
			console.log('userId:' + this.userId);
		},
		computed: {

		},
		methods: {

			toRunSql() {
				if (this.ifLogin == true) {
					let routeUrl = this.$router.resolve({
						path: '/run',
					})
					window.open(routeUrl.href, '_blank')
				} else {
					this.$Message.warning('登录后才能使用该功能！');
				}
			}

		},

	}
</script>

<style lang="scss" scoped>
	//写上样式
	.keyWord {
		color: #0fbda0;
	}


	#vip {
		color: red;
	}

	.about-xs {
 
		margin-bottom: 20px;
		margin-top: 10px;
	}

	//标题字体
	.aw-register-box .mod-body .content h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	//内容字体	
	.aw-register-box .mod-body .content .about-t {
		width: 1040px;
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}


	.aw-register-box .mod-body .content .about-t .at-r {
		width: 596px;
		height: auto;
		float: right;
		text-align: center;
	}

	.aw-register-box .mod-body {
		padding: 10px 10px 10px 10px;
	}

	.aw-register-box .gxgd {
		padding: 10px 10px 10px 10px;
	}


	.about-box {
		width: 1170px;
		margin: 20px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}




	.aw-register-box .mod-body .content .about-t .at-l {
		width: 442px;
		height: auto;
		padding-top: 80px;
		float: left;
		text-align: left;
	}

	.aw-register-box .mod-body .content .about-t .at-l2 {
		width: 496px;
		height: auto;
		float: left;
		text-align: center;
	}

	.aw-register-box .mod-body .content h2.about-cs font {
		color: #e37626;
		font-size: 24px;
	}

	.aw-register-box .mod-bodyx .content h2 {
		margin: 0 0 13px 0;
		color: #333;
		font-size: 18px;
	}

	.aw-register-box .mod-body .content h2.t-center {
		text-align: center;
	}

	.aw-register-box .mod-body .mod-bodyt h2.t-center {
		text-align: center;
	}
</style>
